import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TimeService {

  constructor() { }

  //convert wire to US format. mm/dd/yyyy
  unitedStatesFormat(date: string){
    const dateArray = date.split('-');
    return dateArray[1] + '/' + dateArray[2] + '/' + dateArray[0];
  }

  //wire year format. yyyy-mm-dd
  wireFormatDate(date: Date, addTime: number){
    date.setDate(date.getDate() + addTime)
    var year: any = date.getFullYear();
    var month: any = date.getMonth()+1;
    var dt: any = date.getDate();
    if (dt < 10) {
      dt = '0' + dt;
    }
    if (month < 10) {
      month = '0' + month;
    }
    return year + '-' + month + '-' + dt;
  }

  formatTime(time){
    let hour = time.getHours();
    let minute = time.getMinutes();
    if (hour < 10) {
      hour = '0' + hour;
    }
    if (minute < 10) {
      minute = '0' + minute;
    }
    return  "" + hour + ":" + minute;
  }

  getDateTimeString(dateObj: Date){
    var dateString = this.unitedStatesFormat(dateObj.getFullYear() + '-' + (dateObj.getMonth()+1) + '-' + dateObj.getDate());
    var hours: any = dateObj.getHours()
    var minutes: any = dateObj.getMinutes();
    var post = 'AM'
    if(hours > 12){
      post = 'PM'
      hours = hours - 12;
    }
    if(minutes < 10){
      minutes = '0' + minutes;
    }
    return dateString + ' ' + hours + ':' + minutes + ' ' + post;
  }

  getFirstOfYear(dateObj: Date){
    return new Date(dateObj.getFullYear(), 0, 1, 0, 0, 0);
  }

  getLastOfYear(dateObj: Date){
    new Date(dateObj.getFullYear(), 11, 31, 23, 59, 59);
  }

  getHoursFromString(milTime: string){
    if(!milTime){
      return 0;
    }
    var hrs = milTime.split(':')[0];
    if(hrs.startsWith('0')){
      hrs = hrs.substring(1,hrs.length);
    }
    return Number(hrs);
  }


  getMinutesFromString(milTime: string){
    if(!milTime){
      return 0;
    }
    var min = milTime.split(':')[1];
    if(min.startsWith('0')){
      min = min.substring(1, min.length);
    }
    return Number(min);
  }

  newTimeStamp(){
    // yyyyMMddhhmm
    let date = new Date();
    let x = date.getFullYear() 
    + ("0" + (date.getMonth() + 1)).slice(-2) 
    + ("0" + date.getDate()).slice(-2) 
    + ("0" + date.getHours() + 1 ).slice(-2) 
    + ("0" + date.getMinutes()).slice(-2)
    console.log("new timestamp: ", x);
    return x
  }

  newTimeStampReadableUTC(){
    // MM/dd/yyyy hh:mm am/pm
    let date = new Date(); 
    let x = ("0" + (date.getUTCMonth() + 1)).slice(-2) + "/" + ("0" + date.getUTCDate()).slice(-2) + "/" + date.getUTCFullYear() + " "
    + ("0" + date.getUTCHours() + 1 ).slice(-2) + ":" + ("0" + date.getUTCMinutes()).slice(-2) + " " + (date.getUTCHours() >= 12 ? "pm" : "am")
    console.log("new timestamp: ", x);
    return x
  }

  pad2(n) {  // always returns a string
    return (n < 10 ? '0' : '') + n;
  }

}
